import translate from '../services/translate';

export default function enumFilter(value, enumPath) {
  return value ? translate(`enums.${enumPath}.${value}`) : '';
}
